import { toFormat } from 'core/classes/helpers/DateHelper'

type DisplayDateMode = 'date' | 'dateTime'

export const formatDisplayDate = (value?: string | null, mode: DisplayDateMode = 'date') => {
  if (!value) {
    return '—'
  }

  try {
    return toFormat(value, mode === 'dateTime' ? 'DD MMM YYYY HH:mm' : 'DD MMM YYYY')
  } catch {
    return '—'
  }
}
